import React from "react";

export interface MiniProps {
	children: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal;
	className?: string;
}

const Mini: React.FC<MiniProps> = ({ children, className = "" }) => {
	return <small className={`mini ${className}`}>{children}</small>;
};

export default Mini;
